import { BlockOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Typography } from 'antd';
import { blue } from '@ant-design/colors';

const { Text } = Typography;

const IconWrapper = ({ children, backgroundColor, shape, size }) => {
  return (
    <div
      style={{
        position: 'relative',
        padding: 0,
        lineHeight: '1.6',
        width: size || 19,
        height: size || 19,
        backgroundColor,
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius:
          shape === 'square' ? '2px' : shape === 'round' ? '100%' : '2px',
      }}
    >
      {children && children}
    </div>
  );
};

const OverlayIcon = ({ shape, size }) => {
  const overLay = (
    <Menu style={{ padding: 4, fontWeight: 900 }}>
      <Menu.Item>
        <Text strong>Product Overlay</Text>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={overLay} placement='bottomRight'>
      <div>
        <IconWrapper backgroundColor={blue[5]} shape={shape} size={size}>
          <BlockOutlined style={{ color: 'white' }} />
        </IconWrapper>
      </div>
    </Dropdown>
  );
};

export { OverlayIcon };
